import { API_ERROR_CODE_I18N_ACCESS_PATTERN_RULES } from "./error-code-i18n-patterns-access";
import { API_ERROR_CODE_I18N_DOMAIN_RESOURCE_PATTERN_RULES } from "./error-code-i18n-patterns-domain-resources";
import { API_ERROR_CODE_I18N_PLATFORM_ENVIRONMENT_PATTERN_RULES } from "./error-code-i18n-patterns-platform-environment";
import { API_ERROR_CODE_I18N_PLATFORM_RESOURCE_PATTERN_RULES } from "./error-code-i18n-patterns-platform-resources";
import { API_ERROR_CODE_I18N_RUNTIME_BRIDGE_PATTERN_RULES } from "./error-code-i18n-patterns-runtime-bridges";

export type { ApiErrorCodeI18nPatternRule } from "./error-code-i18n-pattern-types";

import type { ApiErrorCodeI18nPatternRule } from "./error-code-i18n-pattern-types";

export const API_ERROR_CODE_I18N_PATTERN_RULES: readonly ApiErrorCodeI18nPatternRule[] = [
  ...API_ERROR_CODE_I18N_ACCESS_PATTERN_RULES,
  ...API_ERROR_CODE_I18N_DOMAIN_RESOURCE_PATTERN_RULES,
  ...API_ERROR_CODE_I18N_PLATFORM_RESOURCE_PATTERN_RULES,
  ...API_ERROR_CODE_I18N_PLATFORM_ENVIRONMENT_PATTERN_RULES,
  ...API_ERROR_CODE_I18N_RUNTIME_BRIDGE_PATTERN_RULES,
];
